import './toolbar.scss';
import {useMapContext} from '../MapContext';

export function Toolbar() {
    let map = useMapContext();
    return (
        <div class="toolbar">
            <button class={map.isJobsShown() ? 'toolbar-button toolbar-button-active': 'toolbar-button'} onClick={map.toggleJobs}>Experience</button>
            <button class={map.isEduShown() ? 'toolbar-button toolbar-button-active': 'toolbar-button'} onClick={map.toggleEdu}>Education</button>
            <button class={map.isTravelShown() ? 'toolbar-button toolbar-button-active': 'toolbar-button'} onClick={map.toggleTravel}>Travel</button>
            <button class={map.isThreeShown() ? 'toolbar-button toolbar-button-active': 'toolbar-button'} onClick={map.toggleThree}>Interests</button>
        </div>
    );
}

